import {DefaultService} from "./DefaultService";

class Area extends DefaultService {
    getAreas(){
        return this.get('/store/city-list').then(res => res.data)
    }
}

export default Area;